import type { ComponentType } from 'react'
import { LumieBrandMark } from '@/components/landing/lumie/lumie-brand-mark'
import { YeshumanBrandMark } from '@/components/landing/yeshuman/yeshuman-brand-mark'

export type AuthBrandMarkSize = 'sm' | 'md'

const AUTH_BRAND_MARKS: Record<
  string,
  ComponentType<{ navigateHome?: boolean; className?: string; size?: AuthBrandMarkSize }>
> = {
  lumieOrb: LumieBrandMark,
  yeshumanWordmark: YeshumanBrandMark,
}

type AuthBrandMarkProps = {
  markKey: string
  className?: string
  size?: AuthBrandMarkSize
}

export function AuthBrandMark({ markKey, className, size = 'md' }: AuthBrandMarkProps) {
  const Mark = AUTH_BRAND_MARKS[markKey]
  if (!Mark) return null
  return <Mark navigateHome size={size} className={className} />
}
